import React from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { SidebarProvider, useSidebarContext } from '@/contexts/SidebarContext';
import AppSidebar from '@/components/AppSidebar';
import DashboardFooter from '@/components/DashboardFooter';
import { useIsMobile } from '@/hooks/use-mobile';
import { cn } from '@/lib/utils';
import ContentLabDashboard from '@/components/content-lab/ContentLabDashboard';
import ClientsList from '@/components/content-lab/ClientsList';
import ClientDetail from '@/components/content-lab/ClientDetail';
import GenerateTOC from '@/components/content-lab/GenerateTOC';
import TocHistory from '@/components/content-lab/TocHistory';

const ContentLabLayout: React.FC = () => {
  const { compact } = useSidebarContext();
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigate = (page: string) => {
    switch (page) {
      case 'dashboard':
      case 'deep-analysis':
      case 'recommended':
      case 'faq-serp':
        navigate('/dashboard');
        break;
      case 'eco':
        navigate('/eco');
        break;
      case 'fact-check':
        navigate('/fact-check');
        break;
      case 'reddit-hn':
        navigate('/reddit-hn');
        break;
      case 'startup-stash':
        navigate('/startup-stash');
        break;
      case 'grow-geo':
        navigate('/grow-geo');
        break;
      case 'content-lab':
        navigate('/content-lab');
        break;
      default:
        console.log('Unknown:', page);
    }
  };

  const activePage = location.pathname.startsWith('/content-lab') ? 'content-lab' : '';

  return (
    <div className="flex min-h-screen w-full bg-gradient-to-br from-background via-background to-secondary/20">
      <AppSidebar activePage={activePage} onNavigate={handleNavigate} />
      <div className={cn("flex-1 min-w-0 transition-all duration-300", !isMobile && (compact ? "ml-16" : "ml-64"))}>
        <div className="w-full max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <Routes>
            <Route index element={<ContentLabDashboard />} />
            <Route path="clients" element={<ClientsList />} />
            <Route path="clients/:id" element={<ClientDetail />} />
            <Route path="history" element={<TocHistory />} />
          </Routes>
        </div>
        <DashboardFooter />
      </div>
    </div>
  );
};

const ContentLab: React.FC = () => {
  const location = useLocation();

  // Full-window mode for generate route — no sidebar
  if (location.pathname === '/content-lab/generate') {
    return <GenerateTOC />;
  }

  return (
    <SidebarProvider>
      <ContentLabLayout />
    </SidebarProvider>
  );
};

export default ContentLab;
